//! @ngInject
export function approveTaskInstanceUnassignModalCtrl(
    $scope,
    $uibModalInstance,
    noteConsts,
    entityNoteService,
) {
    $scope.visitInstanceId = $scope.$resolve.visitInstanceId;
    $scope.caregiverId = $scope.$resolve.caregiverId;
    $scope.patientId = $scope.$resolve.patientId;
    $scope.approvalNote = {};
    $scope.unassignTaskNote = {};
    $scope.isManualRemoveVisitNoteRequired = true;
    // FOR THE APPROVAL NOTE, WE HAVE requestNoteText, indicates 'billing/paid/payroll draft';

    $scope.approveForm = () => {

        const { isNoteValid, isPredefinedValid, isMessageValid } = entityNoteService.validateEntityNote(
            $scope.unassignTaskNote, noteConsts.NoteTypes.AGENCY_MEMBER_REMOVE_TASK_VISIT
        );
        if (!isNoteValid) {
            $scope.removedVisitNoteValidations = { isPredefinedValid, isMessageValid };
            return;
        }

        if ($scope.$resolve.requestNoteText) {
            const { isNoteValid, isPredefinedValid, isMessageValid } = entityNoteService.validateEntityNote(
                $scope.approvalNote, 
                noteConsts.NoteTypes.ADJUSTMENT_APPROVAL
            );
            if (!isNoteValid) {
                $scope.approvalNoteValidations = { isPredefinedValid, isMessageValid };
                return;
            }
        }

        $scope.unassignTaskNote = entityNoteService.buildEntityNoteRequest(
            $scope.unassignTaskNote, noteConsts.NoteTypes.AGENCY_MEMBER_REMOVE_TASK_VISIT,
        );

        $scope.unassignTaskNote.caregiverId = $scope.caregiverId;
        $scope.unassignTaskNote.patientId = $scope.patientId;

        if ($scope.visitInstanceId) {
            $scope.unassignTaskNote.visitInstanceId = $scope.visitInstanceId;
        }

        if ($scope.$resolve.requestNoteText) {
            $scope.approvalNote = entityNoteService.buildEntityNoteRequest(
                $scope.approvalNote,
                noteConsts.NoteTypes.ADJUSTMENT_APPROVAL,
            );
        }
        $uibModalInstance.close($scope.unassignTaskNote);
    }

    $scope.handleNoteChanges = (noteModel, updatedNote) => {
        $scope[noteModel] = updatedNote;
    };

    $scope.closeModal = function (data) {
        $uibModalInstance.close(data);
    };
};